
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  agreements: [],
  templateKey: '',
  saveAgreementsLoading: false,
  saveAgreementsError: null,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
